(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestseller"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function(){
  const root = document.getElementById('bestsellers-{{ sid }}');
  if(!root) return;

  root.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-quick-add]');
    if(!form) return;
    e.preventDefault();

    const btn = form.querySelector('button[type="submit"]');
    if(btn){ btn.disabled = true; btn.dataset.loading = '1'; }

    try{
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: formData });
      if(!res.ok) throw new Error('Add to cart failed');

      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      const countTargets = document.querySelectorAll('[data-cart-count], #CartCount, .cart-count-bubble__count, .header__cart-count');
      countTargets.forEach(el => { el.textContent = cart.item_count; el.classList.add('is-updated'); });

      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      document.body.classList.add('cart-has-updated');
    } catch(err){
      console.error(err);
      alert("Das Produkt konnte nicht in den Warenkorb gelegt werden.");
    } finally{
      if(btn){ btn.disabled = false; btn.removeAttribute('data-loading'); }
    }
  }, { passive: false });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-container"]) return;
  try {
    
  // Hash-Scroll wie vorher
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const el = document.getElementById(url.hash.slice(1));
        if (el) el.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  // Tabs
  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('[data-categorized-products]');
    if (!root) return;

    const buttons = root.querySelectorAll('[data-tab-button]');
    const panels = root.querySelectorAll('[data-tab-panel]');
    if (!buttons.length || !panels.length) return;

    const setActive = (id) => {
      buttons.forEach((b) => {
        const active = b.getAttribute('data-tab-button') === id;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
        b.setAttribute('tabindex', active ? '0' : '-1');
      });

      panels.forEach((p) => {
        const active = p.getAttribute('data-tab-panel') === id;
        p.hidden = !active;
      });
    };

    const first = buttons[0]?.getAttribute('data-tab-button');
    if (first) setActive(first);

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => setActive(btn.getAttribute('data-tab-button')));

      btn.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();

        const list = Array.from(buttons);
        const idx = list.indexOf(btn);
        const next =
          e.key === 'ArrowRight'
            ? list[idx + 1] || list[0]
            : list[idx - 1] || list[list.length - 1];

        next?.focus();
        next?.click();
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
